import configureAxios from 'configure/axios';

const axios = configureAxios();

export const find = (id) => axios.get(`quick/subscriptions/${id}/`);
export const fetchAll = (user_profile) => axios.get('quick/subscriptions/', { params: { user_profile, quick_status: ['active', 'suspended'] } });
export const updatePlan = (id, plan_id) => axios.post(`quick/subscriptions/${id}/update_plan/`, { plan_id });
export const update = (id, fields) => axios.patch(`quick/subscriptions/${id}/`, fields);